import React from 'react'
import { Card, CardHeader, CardTitle, CardContent } from '@klear/ui/components/card'
import { Settings } from 'lucide-react'
import { useFormContext } from 'react-hook-form'
import FormCheckbox from '@klear/ui/form/checkbox'
import OrganizationForm from '@klear/ui/components/organization-form'
import TraderSubscriptionPanel from '@/app/trader/TraderSubscriptionPanel'
import TraderSenderDomainPanel from '@/app/trader/TraderSenderDomainPanel'

interface TraderOrganizationFormProps {
  isEditing?: boolean
  traderId?: number
}

const TraderOrganizationForm: React.FC<TraderOrganizationFormProps> = ({ isEditing = true, traderId }) => {
  useFormContext()

  return (
    <>
      <OrganizationForm isEditing={isEditing} showIdentifiers={true} showParentOrganization={true} />

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5" />
            Trader Features
          </CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-2 gap-4">
          <div className="space-y-4 flex flex-col gap-2">
            {traderId && <TraderSubscriptionPanel traderId={traderId} />}
            {traderId && <TraderSenderDomainPanel traderId={traderId} />}
            <FormCheckbox
              className="flex flex-row-reverse items-center justify-end gap-2 space-y-0"
              name="hasFx"
              label="Has FX"
              isEditing={isEditing}
            />
          </div>
        </CardContent>
      </Card>
    </>
  )
}

export default TraderOrganizationForm
